import React, { Component, Suspense, useEffect, useRef } from 'react'
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import Navbar from "./components/Navbar";
import {  Switch, Route, BrowserRouter, useLocation } from "react-router-dom";
import Footer from "./components/Footer";
import './styles.scss';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { connect } from 'react-redux';
import { setCurrentComponent, setPlatForm, setSocialMediaData, setUser, setSignUpUser, showLoader } from './actions';
import UserService from './services/UserService';
import * as constants from './constants';
import { instanceOf } from "prop-types";
import { withCookies, Cookies } from "react-cookie";
import { ToastContainer, toast } from 'react-toastify';
import createActivityDetector from 'activity-detector';

const ForStudents = React.lazy(() => import("./pages/ForStudents"));
//const Pricing = React.lazy(() => import("./pages/Pricing"));
const PrivacyPolicy = React.lazy(() => import("./pages/PrivacyPolicy"));
const TermsOfService = React.lazy(() => import("./pages/TermsOfService"));
const ContactUs = React.lazy(() => import("./pages/ContactUs"));
const InstiuteHome = React.lazy(() => import("./pages/InstiuteHome"));
const NotFound = React.lazy(() => import("./pages/NotFound"));
const activityDetector = createActivityDetector({
  timeToIdle: 1000, // wait 5s of inactivity to consider the user is idle
  autoInit: false, // I don't want to start the activity detector yet.
  ignoredEventsWhenIdle: []
});

// Fires a Facebook Pixel PageView on client-side route changes.
// The initial hard-load PageView is already fired by the base pixel code in public/index.html,
// so the first mount is skipped here to avoid double-counting.
function FacebookPixelTracker() {
  const location = useLocation();
  const isInitialLoad = useRef(true);
  useEffect(() => {
    if (isInitialLoad.current) {
      isInitialLoad.current = false;
      return;
    }
    if (window.fbq) {
      window.fbq('track', 'PageView');
    }
  }, [location.pathname]);
  return null;
}

export class App extends Component {
  static propTypes = {
    cookies: instanceOf(Cookies).isRequired
  };
  constructor(props){
    super(props)
    this.state={
      isOpen:false,
      scrollUp: false,
      isSocialSignUp:false,
    }
  }
  componentWillMount(){
    let start, end = 0;
    this.interval = setInterval( () =>{
      var ttime = 0;
      try {
        ttime = localStorage.getItem('active_total_time') ? JSON.parse(localStorage.getItem('active_total_time')) : 0;
      } catch (e) {
        console.error('Error parsing active_total_time:', e);
        localStorage.removeItem('active_total_time');
      }
      var reqData = {
        "total_time": ttime ? ttime : 0
      };
      
      let userToken = null;
      try {
        userToken = localStorage.getItem('userToken') ? JSON.parse(localStorage.getItem('userToken')) : null;
      } catch (e) {
        console.error('Error parsing userToken:', e);
        localStorage.removeItem('userToken');
      }
      if (userToken && userToken.length) {
        UserService.saveActivities(reqData, (err, response) => {
          if (err) {
            // errors["response"] = err.message;
            // me.setState({errors: errors});
          }
          else {
            // Success
            localStorage.setItem('active_total_time', JSON.stringify(0));
          }
        });
      }

    }, 60000);



    activityDetector.on('idle', () => {
      end = new Date();
      if (end && start) {
        let time = 0;
        try {
          time = localStorage.getItem('active_total_time') ? JSON.parse(localStorage.getItem('active_total_time')) : 0;
        } catch (e) {
          console.error('Error parsing active_total_time in activity detector:', e);
          localStorage.removeItem('active_total_time');
        }

        let betTime =  time+ (end - start);

        localStorage.setItem('active_total_time', JSON.stringify(betTime));
      }
    });
    activityDetector.on('active', () => {
      start = new Date();
    });
    activityDetector.init();
  }
  componentWillUnmount() {
    clearInterval(this.interval);
  }
  componentDidMount(){
    // Check for payment success first — if handled, skip the rest to avoid
    // race conditions where handleLoginUser/me() calls could clear auth data
    const paymentHandled = this.checkPaymentSuccess();
    if (paymentHandled) return;

    let user = localStorage.getItem('user');
    try {
      this.props.setUser(user ? JSON.parse(user) : null);
    } catch (e) {
      console.error('Error parsing user data:', e);
      this.props.setUser(null);
      localStorage.removeItem('user');
    }
    
    this.props.showLoader(false);
    const { cookies } = this.props;
    
    let keepMeLoggedIn = null;
    let userLoggedIn = null;
    
    try {
      keepMeLoggedIn = localStorage.getItem('keepMeLoggedIn') ? JSON.parse(localStorage.getItem('keepMeLoggedIn')) : null;
    } catch (e) {
      console.error('Error parsing keepMeLoggedIn:', e);
      localStorage.removeItem('keepMeLoggedIn');
    }
    
    try {
      userLoggedIn = sessionStorage.getItem('userLoggedIn') ? JSON.parse(sessionStorage.getItem('userLoggedIn')) : null;
    } catch (e) {
      console.error('Error parsing userLoggedIn:', e);
      sessionStorage.removeItem('userLoggedIn');
    }
    this.handleLoginUser(cookies);
    if (!cookies.cookies.userToken) {
      // Cookie missing — check if "Keep me signed in" was checked and we have a stored token
      if (keepMeLoggedIn && localStorage.getItem('userToken')) {
        // Restore cookie from localStorage so handleLoginUser can refresh it
        let storedToken = localStorage.getItem('userToken');
        this.handleCookie(storedToken);
        this.handleLoginUser(cookies);
      } else {
        this.flushData();
      }
    } else if (!userLoggedIn && !keepMeLoggedIn && !localStorage.getItem('userToken')) {
      // Token cookie exists (set on another subdomain) but no local session — fetch user data
      let token = null;
      try {
        token = JSON.parse(cookies.cookies.userToken);
      } catch (e) {
        console.error('Error parsing userToken cookie:', e);
      }
      if (token) {
        localStorage.setItem('userToken', JSON.stringify(token));
        UserService.me((err, res) => {
          if (!err) {
            localStorage.setItem('user', JSON.stringify(res));
            this.props.setUser(res);
          } else {
            this.flushData();
          }
        });
      }
    }
    if (window.opener && window.opener !== window) {
      const code = this.getCodeFromWindowURL(window.location.href,'code');
      window.opener.postMessage({'type': 'code', 'code': code}, '*')
      window.close();
    }
    window.addEventListener('message', this.handlePostMessage);
    this.save();
    
    if(localStorage.getItem('userToken')){
      UserService.me((err,res)=>{
        if (!err) {
          localStorage.setItem('user', JSON.stringify(res));
          this.props.setUser(res);
          this.setIsOpen(false);
          this.save();
        }else{
          this.props.setUser(null);
        }

      })
    }
    
  }
  handlePostMessage = event => {
    if (event.data.type === 'code') {
      const { code } = event.data;
      this.getUserCredentials(code);
    }
  };
  getCodeFromWindowURL = (url,code) => {
      const popupWindowURL = new URL(url);
      return popupWindowURL.searchParams.get(code);
  };
  redirectToMYT = () => {
    window.open(process.env.REACT_APP_MYT_REDIRERT_URL, '_blank');
  }

  getUserCredentials = xcode => {
    this.props.setPlatform(constants.SOCIAL_MEDIA.LINKEDIN)
    UserService.getLinkedInInfo({socialMedia:constants.SOCIAL_MEDIA.LINKEDIN,code:xcode},(err,response)=>{
      if (!err && response) {
        if (this.props.type === constants.TYPE.SIGNUP) {
          const socialMediaData = {
            name: response.profile.name.givenName + ' ' + response.profile.name.familyName,
            email: response.profile.emails[0].value,
            access_token: response.accessToken
          }
          this.setIsSocialSignUp(true)
          this.props.setSocialMediaData(socialMediaData);
          if (response.accessToken) {
            
            this.props.setCurrentComponent(constants.SHOWCOMPONENT.SOCIALSIGNUP)
          }        
        }else {
          this.socialLogin(response)
        }
      }
    })
  };
  socialLogin = (response) =>{
    let access_token = response.accessToken;
    let reqData = {
      social_login: true,
    };
    UserService.getSocialMediaInfo(
      access_token,
      reqData,
      constants.SOCIAL_MEDIA.LINKEDIN,
      (err, response) => {
        if (!err && response) {
          localStorage.setItem(
            'userToken',
            JSON.stringify(response.token)
          );
          this.handleCookie(JSON.stringify(response.token));
          localStorage.setItem(
            'user',
            JSON.stringify(response.user)
          );
          this.props.setUser(response.user);
          this.setIsOpen(false);
          window.location.href = process.env.REACT_APP_REDIRECT_LOGIN_URL
            + 'auth/login?token=' + encodeURIComponent(response.token)
            + '&keepMeLoggedIn=false';
        } else if(err.code==="ERR006") {
          toast.error(err.message, {
            theme:'colored',
            autoClose: constants.TOAST_TIMEOUT_MEDIUM
          });
        }
      }
    );
  }
  handleCookie = (token) => {
		const { cookies } = this.props;
		if (token) {
			cookies.set('userToken', token, constants.COOKIE_OPTIONS); // setting the cookie
			cookies.set('redirectFromWebsite', true, constants.COOKIE_OPTIONS);
			cookies.set('websiteUser', true, constants.COOKIE_OPTIONS);
		}
	};
  setIsOpen = (open) => {
    this.setState({isOpen:open})
  }
  flushData(){
    const { cookies } = this.props;
    this.props.setUser(null);
    this.props.setSignUpUser(null);
    cookies.remove("upgrade", constants.COOKIE_OPTIONS);
    cookies.remove("userToken", constants.COOKIE_OPTIONS);
    cookies.remove("keepMeLoggedIn", constants.COOKIE_OPTIONS);
    localStorage.clear();
    clearInterval(this.interval);

  }
  save = () => {
    const { cookies } = this.props;
    this.interval = setInterval(() => {
        if (!cookies.cookies.userToken) {
          this.flushData();
        }
    }, 60000);
  }
  showTenDayFree=()=>{
    if(window.innerWidth <= 950){
      if (window.pageYOffset > 200) {
        this.setState({scrollUp : true})
      } else {
        this.setState({scrollUp : false})
      }
    }else if(window.pageYOffset > 420) {
      this.setState({scrollUp : true})
    } else {
      this.setState({scrollUp : false})
    }
  }
  setTenDayButton = () => {
    this.setState({scrollUp : true});
  }
  setIsSocialSignUp = (isSocialSignUp) => {
    this.setState({isSocialSignUp:isSocialSignUp})
  }
  checkPaymentSuccess = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const status = urlParams.get('status');
    const paymentInProgress = localStorage.getItem('paymentInProgress');

    console.log('=== GLOBAL PAYMENT CHECK ===');
    console.log('URL Status:', status);
    console.log('Payment in progress:', paymentInProgress);
    console.log('===========================');

    // Handle malformed URLs with duplicate parameters
    const isSuccess = status && (status === 'success' || status.includes('success'));
    const isFailure = status && (status === 'failure' || status.includes('failure'));

    if (isSuccess && paymentInProgress === 'true') {
      localStorage.removeItem('paymentInProgress');
      this.handlePaymentSuccess();
      return true; // Signal that payment was handled
    } else if (isFailure && paymentInProgress === 'true') {
      localStorage.removeItem('paymentInProgress');
      toast.error('Payment failed. Please try again.', {
        theme: 'colored',
        autoClose: constants.TOAST_TIMEOUT_MEDIUM
      });
      // Clear URL params
      window.history.replaceState({}, document.title, window.location.pathname);
    }
    return false;
  }

  handlePaymentSuccess = () => {
    console.log('=== GLOBAL PAYMENT SUCCESS ===');

    // Clear URL params
    window.history.replaceState({}, document.title, window.location.pathname);

    // Try sessionStorage first, fall back to localStorage
    // (sessionStorage can be lost during payment gateway redirects in some browsers)
    let signupResponse = sessionStorage.getItem('signupResponse') || localStorage.getItem('signupResponse');
    if (signupResponse) {
      const response = JSON.parse(signupResponse);

      // Store tokens
      localStorage.setItem('userToken', JSON.stringify(response.token));
      localStorage.setItem('user', JSON.stringify(response.user));

      // Set cookies
      const { cookies } = this.props;
      cookies.set('userToken', JSON.stringify(response.token), constants.COOKIE_OPTIONS);
      cookies.set('redirectFromWebsite', true, constants.COOKIE_OPTIONS);
      cookies.set('websiteUser', true, constants.COOKIE_OPTIONS);

      if (response.user?.payment_order_id) {
        cookies.set('paymentOrderId', JSON.stringify(response.user.payment_order_id), constants.COOKIE_OPTIONS);
      }

      // Clean up
      sessionStorage.removeItem('signUpFormData');
      sessionStorage.removeItem('signupResponse');
      sessionStorage.removeItem('selectedModule');
      localStorage.removeItem('signupResponse');

      console.log('Tokens set, refreshing via login API before redirect');

      // Refresh token via login API to get a fresh token after payment
      // The stored token is from before payment and may be stale
      let me = this;
      let reqData = {
        token: response.token,
        website: true,
        external: true,
      };
      UserService.login(reqData, function (err, res) {
        if (!err && res) {
          // Update with fresh token
          console.log('Token refreshed successfully, redirecting');
          localStorage.setItem('userToken', JSON.stringify(res.token));
          localStorage.setItem('user', JSON.stringify(res.user));
          cookies.set('userToken', JSON.stringify(res.token), constants.COOKIE_OPTIONS);
          me.props.setUser(res.user);
        } else {
          console.log('Token refresh failed, redirecting with existing token');
        }
        // Redirect regardless — fresh token if login succeeded, original token otherwise
        let redirectToken = (!err && res) ? res.token : response.token;
        window.location.href = process.env.REACT_APP_REDIRECT_LOGIN_URL
          + 'auth/login?token=' + encodeURIComponent(redirectToken)
          + '&keepMeLoggedIn=false';
      });

      toast.success('Payment successful! Redirecting to the platform...', {
        theme: 'colored',
        autoClose: 3000
      });
    } else {
      console.error('No signup response found after payment');
      toast.error('Payment successful but unable to auto-login. Please login manually.', {
        theme: 'colored',
        autoClose: constants.TOAST_TIMEOUT_MEDIUM
      });
    }
  }
  
  handleLoginUser = (cookies) => {
    if(cookies.cookies.userToken){
      let me = this;
      let token = null;
      
      try {
        token = cookies.cookies.userToken ? JSON.parse(cookies.cookies.userToken) : null;
      } catch (e) {
        console.error('Error parsing userToken cookie:', e);
        return;
      }
      
      let reqData = {
        token: token,
        website: true,
        external: true,
      };
      UserService.login(reqData, function (err, res) {
        if(!err && res){
          me.setState({ isLoading: false });
          localStorage.setItem('userToken', JSON.stringify(res.token));
          me.handleCookie(JSON.stringify(res.token));
          sessionStorage.setItem('userLoggedIn', true);
          localStorage.setItem('user', JSON.stringify(res.user));
          me.props.setUser(res.user);
        } else if (err && err.code !== 0) {
          // The shared-cookie token is dead (expired/invalid). Clear it so future
          // page loads — and the signup → platform handoff — start from a clean
          // slate instead of retrying the dead token on every load. A network
          // failure (code 0) must NOT clear the session.
          cookies.remove('userToken', constants.COOKIE_OPTIONS);
          cookies.remove('redirectFromWebsite', constants.COOKIE_OPTIONS);
          cookies.remove('websiteUser', constants.COOKIE_OPTIONS);
          localStorage.removeItem('userToken');
          localStorage.removeItem('user');
          sessionStorage.removeItem('userLoggedIn');
          me.props.setUser(null);
        }
      })
    }
  }
    render(){
    return (
      <>
        <head>
          <link
            rel="apple-touch-icon"
            sizes="180x180"
            href="/apple-touch-icon.png"
          />
          <link
            rel="icon"
            type="image/png"
            sizes="32x32"
            href="/favicon-32x32.png"
          />
          <link
            rel="icon"
            type="image/png"
            sizes="16x16"
            href="/favicon-16x16.png"
          />
          <link rel="manifest" href="/site.webmanifest" />
          <link rel="mask-icon" href="/safari-pinned-tab.svg" color="#5bbad5" />
          <meta name="msapplication-TileColor" content="#da532c" />
          <meta name="theme-color" content="#ffffff"></meta>
        </head>
        <ToastContainer hideProgressBar={true}/>
        <BrowserRouter>
          <FacebookPixelTracker />
          <Navbar saveActivity={this.save} redirectToMYT={this.redirectToMYT} setIsOpen={(open)=>this.setIsOpen(open)} isOpen={this.state.isOpen} scrollUp={this.state.scrollUp} isSocialSignUp={this.state.isSocialSignUp} setIsSocialSignUp={(isSocialSignUp)=>this.setIsSocialSignUp(isSocialSignUp)}/>
          <Suspense fallback={<div></div>}>
          <Switch>
            <Route exact path="/InstiuteHome" render={(props)=><InstiuteHome {...props} setIsOpen={(open)=>this.setIsOpen(open)} redirectToMYT={this.redirectToMYT} scrollUp={this.state.scrollUp} showTenDayFree={()=>this.showTenDayFree()}/>} />
            <Route path="/" exact render={(props)=><ForStudents {...props} setTenDayButton= {() => this.setTenDayButton()} setIsOpen={(open)=>this.setIsOpen(open)} setCurrentComponent={this.props.setCurrentComponent} isOpen={this.state.isOpen} scrollUp={this.state.scrollUp} showTenDayFree={()=>this.showTenDayFree()} />} />
            <Route path="/ContactUs" exact render={(props)=><ContactUs {...props}/>} />
            {/* <Route path="/Pricing" exact render={(props)=><Pricing {...props} setIsOpen={(open)=>this.setIsOpen(open)} setTenDayButton= {() => this.setTenDayButton()} />} /> */}
            <Route path="/TermsOfService" exact render={(props)=><TermsOfService {...props}/>} />
            <Route path="/PrivacyPolicy" exact render={(props)=><PrivacyPolicy {...props}/>} />
            <Route component={NotFound} />
          </Switch>
          </Suspense>
          <Footer redirectToMYT={this.redirectToMYT} />
        </BrowserRouter>
      </>
    );

  }
}
const mapStateToProps = state => ({
  user: state.webSiteUser.user,
  type: state.webSiteUser.type,
  loader: state.webSiteUser.loader
})
const mapDispatchToProps = dispatch => ({
  setSocialMediaData: data => dispatch(setSocialMediaData(data)),
  setPlatform: platform => dispatch(setPlatForm(platform)),
  setUser: user => dispatch(setUser(user)),
  setCurrentComponent: currentComponent => dispatch(setCurrentComponent(currentComponent)),
  setSignUpUser: signUpUser => dispatch(setSignUpUser(signUpUser)),
  showLoader: loader => dispatch(showLoader(loader)),
})
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withCookies(App))
